module.exports = __webpack_public_path__ + "static/section-5-img-1@2x-6426d02f7decf052c72024e6c149b637.png";